(function () {
  var root = document.documentElement;
  var stored = localStorage.getItem('color-scheme');
  var toggle = document.querySelector('[data-color-scheme-toggle]');

  function apply(scheme) {
    root.setAttribute('data-color-scheme', scheme);
    root.setAttribute('data-scheme', scheme);
    localStorage.setItem('color-scheme', scheme);
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      var current = root.getAttribute('data-color-scheme') || 'light';
      apply(current === 'dark' ? 'light' : 'dark');
    });
  }

  if (!stored) {
    var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    apply(prefersDark ? 'dark' : 'light');
  }
})();